module.exports = __webpack_public_path__ + "static/media/Lion.318d076d.png";